import { createContext } from 'react';
import { SnackbarProps } from 'js/social/shared/SnackBar';

type SnackbarContextProps = {
  showSnackbar: (
    message: SnackbarProps['message'],
    type: SnackbarProps['type'],
    onClick?: SnackbarProps['onClick'],
    durationInMs?: SnackbarProps['durationInMs'],
    showIcon?: SnackbarProps['showIcon'],
  ) => void;
};

export const SnackbarContext = createContext<SnackbarContextProps>({
  showSnackbar: () => {},
});
